import {
  jb_market_display_css_default
} from "./chunk.76BHFKFA.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-market-display/jb-market-display.ts
var JbMarketDisplay = class extends r {
  render() {
    return ke`
      <div>
        <span class="short">${this.marketShortName}</span>
        <span class="long">${this.marketName}</span>
      </div>
    `;
  }
};
JbMarketDisplay.styles = [reset_css_default, jb_market_display_css_default];
__decorateClass([
  n()
], JbMarketDisplay.prototype, "marketName", 2);
__decorateClass([
  n()
], JbMarketDisplay.prototype, "marketShortName", 2);
JbMarketDisplay = __decorateClass([
  customElement("jb-market-display")
], JbMarketDisplay);

export {
  JbMarketDisplay
};
